import { fetchOrGenerateUserPermissionsForSchedulingInstance } from '../apis/schedulingInstances';
import { ERROR_NAVIGATING_TO_INSTANCE } from '../const/messageCodes';
import { SchedulingInstance } from '../models/SchedulingInstance';
import { disableGlobalLoader, enableGlobalLoader } from '../stores/applicationSettings';
import { selectEnterprise } from '../stores/currentUser';
import { sendErrorMessageWithCode } from '../stores/messages';
import { RootState } from '../stores/rootReducer';
import { useAppDispatch, useAppSelector } from '../stores/store';

export const useSchedulingInstanceActions = () => {
  const dispatch = useAppDispatch();
  const { enterpriseId } = useAppSelector((state: RootState) => ({
    enterpriseId: selectEnterprise(state.currentUser)?.id,
  }));

  const viewSchedulingInstanceAsUser = async (schedulingInstance: SchedulingInstance): Promise<void> => {
    if (!enterpriseId) {
      return Promise.reject();
    }
    try {
      dispatch(enableGlobalLoader());
      await fetchOrGenerateUserPermissionsForSchedulingInstance(enterpriseId, schedulingInstance.id);
      if (schedulingInstance.adminUrl) {
        window.location.href = schedulingInstance.adminUrl;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      dispatch(sendErrorMessageWithCode(ERROR_NAVIGATING_TO_INSTANCE));
      dispatch(disableGlobalLoader());
    }
  };

  return { viewSchedulingInstanceAsUser };
};
